export default {
    data() {
        return {
            selectedItemNumber: null,
            itemUnderMatchNumber: null,
            matchBoxNumbers: [],
            matchedItemsCount: 0,

            dragAndDrop: {
                dragItem: null,
                currentX: null,
                currentY: null,
                initialX: null,
                initialY: null,
                active: false
            }
        };
    },

    methods: {
        setMatchBoxesNumbers() {
            this.matchBoxNumbers = [...this.stepItems.map(item => item.number.split('-')[0])];
        },

        dragStart(e) {
            this.selectedItemNumber = e.target.attributes.number.value;

            if (e.type === 'touchstart') {
                this.dragAndDrop.initialX = e.touches[0].clientX;
                this.dragAndDrop.initialY = e.touches[0].clientY;
            } else {
                this.dragAndDrop.initialX = e.clientX;
                this.dragAndDrop.initialY = e.clientY;
            }

            this.dragAndDrop.active = true;
            this.dragAndDrop.dragItem = e.target;

            this.setPointerEvent(false);
            this.setDraggedItemZIndex(10);
        },

        setPointerEvent(flag) {
            const { dragItem } = this.dragAndDrop;

            dragItem.style.pointerEvents = flag ? 'auto' : 'none';
        },

        setDraggedItemZIndex(zIndex) {
            const { dragItem } = this.dragAndDrop;

            dragItem.style.zIndex = zIndex;
        },

        drag(e) {
            const { active, initialX, initialY, currentX, currentY } = this.dragAndDrop;

            if (active) {
                if (e.type === 'touchmove') {
                    this.dragAndDrop.currentX = e.touches[0].clientX - initialX;
                    this.dragAndDrop.currentY = e.touches[0].clientY - initialY;
                } else {
                    this.dragAndDrop.currentX = e.clientX - initialX;
                    this.dragAndDrop.currentY = e.clientY - initialY;
                }

                this.setDraggedItemPosition({ x: currentX, y: currentY });
            }
        },

        setDraggedItemPosition(cords) {
            const { dragItem } = this.dragAndDrop;
            const { x, y } = cords;

            dragItem.style.transform = `translate3d(${x}px,${y}px,0)`;
        },

        dragEnd(e) {
            const { dragItem } = this.dragAndDrop;

            if (dragItem) {
                if (e.type === 'touchend') {
                    this.handleMobileDrop(e);
                } else {
                    this.handleDrop(e);
                }

                this.resetDragAndDrop();
            }

            this.dragAndDrop.active = false;
        },

        handleMobileDrop(e) {
            const matchedTile = document.elementFromPoint(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            const areItemsMatching = this.selectedItemNumber === matchedTile.innerText;

            if (areItemsMatching) {
                this.handleItemMatch();
            }
        },

        handleDrop(e) {
            const matchedTile = document.elementFromPoint(e.clientX, e.clientY);
            const areItemsMatching = this.selectedItemNumber === matchedTile.innerText;

            if (areItemsMatching) {
                this.handleItemMatch();
            }
        },

        resetDragAndDrop() {
            this.setDraggedItemZIndex(0);
            this.setDraggedItemPosition({ x: 0, y: 0 });
            this.resetDraggedItemCords();
            this.resetItemsMatchingInfo();
            this.setPointerEvent(true);
        },

        handleItemMatch() {
            this.removeMatchedItemFromSelectArea();
            this.goToFirstSlideIfNoItems();
            this.addItemIntoMatchingArea();
        },

        removeMatchedItemFromSelectArea() {
            const imageName = this.stepItems.find(stepItem => stepItem.number.split('-')[0] === this.selectedItemNumber)
                .number;

            this.stepItems = this.stepItems.filter(item => item.number !== imageName);
        },

        goToFirstSlideIfNoItems() {
            if (this.stepItems.length <= this.carousel.itemsPerSlide * this.carousel.activeSlideIndex) {
                this.carousel.activeSlideIndex = 0;
            }
        },

        addItemIntoMatchingArea() {
            const matchArea = document.querySelector('.drop-boxes');
            const matchedTile = matchArea.querySelector(`.drop-box[number="${this.selectedItemNumber}"]`);

            matchedTile.style.backgroundImage = `url(${this.createImagePath(this.selectedItemNumber)})`;
            matchedTile.style.backgroundPosition = 'center';
            matchedTile.style.backgroundSize = '100% 100%';
            matchedTile.style.border = 'none';
            matchedTile.innerHTML = '';

            this.matchedItemsCount++;

            this.animateMatchedItem(matchedTile);
        },

        animateMatchedItem(matchedTile) {
            matchedTile.style.transform = 'scale(1.2)';

            setTimeout(() => {
                matchedTile.style.transform = 'scale(1)';
            }, 300);
        },

        resetDraggedItemCords() {
            this.dragAndDrop.currentX = null;
            this.dragAndDrop.currentY = null;
        },

        resetItemsMatchingInfo() {
            this.selectedItemNumber = null;
            this.itemUnderMatchNumber = null;
        },

        iluminateTile(e) {
            const { dragItem } = this.dragAndDrop;
            if (dragItem) {
                e.target.style.backgroundColor = 'hsla(0, 0%, 100%, 0.5)';
            }
        },

        resetIluminationFromTile(e) {
            e.target.style.backgroundColor = 'inherit';
        }
    }
};
